import axios from "../axios/axios";
import { ItemStockOverviewResponse } from "../types/stockOverview.types";
import { STOCK_OVERVIEW_PAGE_SIZE } from "../utils/consultOrder.constants";

// Adapter for GET /item_in_marketplace/stock_overview/{id_item} (ITAM-2613).
// The endpoint is permitAll, so the shared axios instance is safe (no
// legitimate-403 logout risk).

export interface StockOverviewQuery {
  page: number;
  priorityMarketplaceId: number;
  priorityMarketplaceBranchId: number;
}

export const fetchItemStockOverview = (
  itemId: number,
  { page, priorityMarketplaceId, priorityMarketplaceBranchId }: StockOverviewQuery,
  signal?: AbortSignal
): Promise<ItemStockOverviewResponse> =>
  axios
    .get<ItemStockOverviewResponse>(
      `/item_in_marketplace/stock_overview/${itemId}`,
      {
        params: {
          page: Math.max(0, page), // negative page 500s on the backend
          numOfReturns: STOCK_OVERVIEW_PAGE_SIZE,
          // Always both ids: they are required, valid app-wide identifiers
          // whenever marketplaceInfo exists (a half-missing pair would silently
          // disable the pin; 0/negative would 400 the whole request).
          priorityMarketplaceId,
          priorityMarketplaceBranchId,
          // NO sort param, and none may ever be sent: an explicit sort DISABLES
          // the backend's distance ordering. Default order is pin-first, then
          // distance ASC from the endpoint's hardcoded default latitude/longitude
          // (the pharmacy's own coordinates), then itemLoyaltyPoints DESC, then
          // itemQuantity DESC. Only in-stock rows (itemQuantity >= 1) within the
          // default 600 km radius are returned.
          // (sort format is 'field:asc'. The doc's 'field,asc' example 500s.)
        },
        signal,
      }
    )
    .then((res) => res.data);
